/**
 * @fileoverview Debug Console Plugin
 *
 * Plugin Nuxt per gestire selettivamente i metodi console in base all'environment.
 * In produzione disabilita console.log, console.info, console.debug mantenendo
 * console.warn e console.error per issues critici.
 *
 * @author TabsLayout Migration
 * @since 2025-09-25
 */ interface Console {
	log: (...args: any[]) => void;
	info: (...args: any[]) => void;
	warn: (...args: any[]) => void;
	error: (...args: any[]) => void;
	debug: (...args: any[]) => void;
	trace: (...args: any[]) => void;
}

/**
 * Backup dei metodi console originali
 */
const originalConsole: Console = {
	log: console.log,
	info: console.info,
	warn: console.warn,
	error: console.error,
	debug: console.debug,
	trace: console.trace,
};

/**
 * Funzione per disabilitare console methods in produzione
 */
const setupConsoleOverride = (): void => {
	if (process.env.NODE_ENV === 'production') {
		// Disabilita metodi debug in produzione
		console.log = () => {};
		console.info = () => {};
		console.debug = () => {};
		console.trace = () => {};

		// Mantieni warn e error per issues critici
		console.warn = originalConsole.warn;
		console.error = originalConsole.error;
	} else {
		// Development: mantieni tutti i metodi
		console.log = originalConsole.log;
		console.info = originalConsole.info;
		console.warn = originalConsole.warn;
		console.error = originalConsole.error;
		console.debug = originalConsole.debug;
		console.trace = originalConsole.trace;

		console.info('🔊 Debug console methods enabled in development');
	}
};

/**
 * Funzione per ripristinare console originale
 */
export const restoreConsole = (): void => {
	Object.assign(console, originalConsole);
};

/**
 * Plugin Nuxt per setup automatico console override
 */
export default function debugConsolePlugin(): void {
	setupConsoleOverride();
}

/**
 * Esporta setup per uso manuale se necessario
 */
export { setupConsoleOverride, originalConsole };
